import { API, graphqlOperation } from "aws-amplify";
//import { onUpdateOrder } from "../graphql/mySubscriptions";
import { ordersByUpdatedDate } from "../graphql/myQueries";

const useListSendedOrders = () => {
  let newOrders = [];

  const getSendedOrders = async () => {
    try {
      const result = await API.graphql(
        graphqlOperation(ordersByUpdatedDate, {
          order_type: "PRESENCIAL",
          status: "ENVIADA",
        })
      );
      var initialArray = result.data.ordersByUpdatedDate.items;
      var newArray = [];
      initialArray.forEach((element) => {
        let history_order = element.history
          ? JSON.parse(element.history)
          : [{ hour: element.updatedAt }];
        element.updatedAt = history_order[0].hour;
        newArray.push(element);
      });
      newOrders = newArray;
      return newArray;
    } catch (error) {
      console.log("Error al listar las ordenes ", error);
      return [];
    }
  };

  return { getSendedOrders, newOrders };
};

export default useListSendedOrders;
